import { defineMessages } from 'react-intl';

export default defineMessages({
    insuredResidence: {
        id: 'ml.quoteandbind.ho.policySummary.Insured Residence',
        defaultMessage: 'Insured Residence'
    }
});
